import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Animated } from '../animated';
import { Theme } from '../../../modules/headerBar/themes';
import { AnimationContainer, ScrollContainer } from './animatedOverlay.styles';
import { BodyScrollLock } from '../bodyScrollLock';

export class AnimatedOverlay extends PureComponent {
  static propTypes = {
    visible: PropTypes.bool,
    disableAnimation: PropTypes.bool,
    children: PropTypes.any,
    headerTheme: PropTypes.oneOf(Object.values(Theme)),
    setHeaderTheme: PropTypes.func.isRequired,
  };

  previousHeaderTheme = this.props.headerTheme;

  handleEntered = () => {
    this.previousHeaderTheme = this.props.headerTheme;
    this.props.setHeaderTheme(Theme.HIDDEN);
  };

  handleExit = () => {
    this.props.setHeaderTheme(this.previousHeaderTheme);
  };

  render() {
    return (
      <Animated
        onEnter={this.handleEnter}
        onEntered={this.handleEntered}
        onExit={this.handleExit}
        visible={this.props.visible}
        disableAnimation={this.props.disableAnimation}
      >
        {ReactDOM.createPortal(
          <AnimationContainer>
            <BodyScrollLock>
              <ScrollContainer>{this.props.children}</ScrollContainer>
            </BodyScrollLock>
          </AnimationContainer>,
          document.body
        )}
      </Animated>
    );
  }
}
